import tw, { styled } from "twin.macro"

export const MenuButton = styled.button`
  ${tw`block lg:hidden`}
  ${({ active }) => (active ? tw`bg-beige text-black` : null)}
`
